import AsyncSearchInput from "@/manager/components/search-input/async-search-input";
import SearchInput from "@/manager/components/search-input/search-input";
import Datepicker, { IDates } from "@/shared/components/datepicker/datepicker";
import TextInput from "@/shared/components/text-input/text-input";
import { modelTypeOptions } from "@/shared/utils/static-values";
import { IDataset } from "./dataset-edit";
import { useParams } from "react-router";

interface IDatasetConfigurationTabProps {
  data: IDataset;
  setData: (data: IDataset) => void;
}

const DatasetConfigurationTab = ({data, setData}: IDatasetConfigurationTabProps) => {
  const params = useParams();

  return <div className="datasetConfigurationTab">
    <TextInput
      label={"Dataset name"}
      type={"text"}
      id={"dataset-name"}
      required={true}
      inputKey={"dataset_name"}
      handleOnChange={(newValue) => setData({...data, dataset_name: newValue})}
      controlled={true}
      autofocus={true}
      value={data.dataset_name}
    />
    <AsyncSearchInput 
      inputKey="event_type"
      handleOnChange={(newOption) => setData({...data, event_id: newOption?.id || ""})}
      label="Event type"
      readonly={!!params.id}
      required={true}
      data={[]}
      selectedOption={data.event_id}
      onFocusEmpty={true}
      url={{
        url: "datamodel/events",
        backend: "platform"
      }}
    />
    <AsyncSearchInput 
      inputKey="TMS_config" 
      handleOnChange={(newOption) => setData({...data, tmsconfig_id: newOption?.id || ""})} 
      label="TMS config settings" 
      required={true}
      data={[]}
      selectedOption={data.tmsconfig_id}
      onFocusEmpty={true}
      url={{
        url: "tmsconfigs",
        backend: "analytics"
      }}
    />
    <AsyncSearchInput 
      inputKey="analytics_report_template" 
      handleOnChange={(newOption) => setData({...data, selected_template_layout_id: newOption?.id || ""})} 
      label="Report template" 
      required={false}
      data={[]}
      selectedOption={data.selected_template_layout_id || ""}
      onFocusEmpty={true}
      url={{
        url: "tenant_templates/analytics_report_template",
        backend: "analytics"
      }}
    />

    <AsyncSearchInput 
      inputKey="analytics_report_pdf_template" 
      handleOnChange={(newOption) => setData({...data, selected_pdf_template_layout_id: newOption?.id || ""})} 
      label="PDF Report template" 
      required={false}
      data={[]}
      selectedOption={data.selected_pdf_template_layout_id || ""}
      onFocusEmpty={true}
      url={{
        url: "tenant_templates/analytics_report_pdf_template",
        backend: "analytics"
      }}
    />
    <SearchInput 
      inputKey="model_type" 
      handleOnChange={(newOption) => setData({...data, model_type: newOption?.id || ""})}
      label="Model type" 
      required={true}
      data={modelTypeOptions}
      selectedOption={data.model_type}
      onFocusEmpty={true}
    />
    <Datepicker
      data={{from: data.timeframe_from || "", until: data.timeframe_to || ""}}
      label="Timeframe"
      handleOnChange={({from, until}: IDates) => setData({...data, timeframe_from: from, timeframe_to: until})}
      key="timeframe"
      valueType="month"
    />
  </div>
};

export default DatasetConfigurationTab;